/**
 * Ordered walkthrough steps spanning the Rules page and every Theme Update tab.
 * `tabId` (when present) tells ThemeUpdate which tab to switch to for that step.
 */
export const TOUR_STEPS = [
  {
    page: "/admin/rules",
    targetId: "tour-rules-list",
    title: "Game Rules",
    content: "Add up to 6 rules shown to players before they start the game. Use + Add rule to add more, or remove any you don't need.",
    placement: "right",
  },
  {
    page: "/admin/rules",
    targetId: "tour-rules-settings",
    title: "Game Settings",
    content: "Set the heading text, correct/wrong points per item, and the colors used across the game and rules popup.",
    placement: "left",
  },
  {
    page: "/admin/rules",
    targetId: "tour-rules-save",
    title: "Save & Continue",
    content: "Save your rules and settings here, then move on to Theme Update to configure items, mascots, and more.",
    placement: "top",
  },
  {
    page: "/admin/themeupdate",
    tabId: "items",
    targetId: "tour-tu-tabs",
    title: "Theme Sections",
    content: "Switch between Items, Idle Hearts, Clouds, Feedback Emojis, and Leaderboard settings from these tabs. The tour will walk through each one.",
    placement: "bottom",
  },
  {
    page: "/admin/themeupdate",
    tabId: "items",
    targetId: "tour-tu-items-grid",
    title: "Good & Bad Items",
    content: "Add the items players sort into good and bad for heart health. Each item needs a name and a mascot GIF the heart acts out.",
    placement: "top",
  },
  {
    page: "/admin/themeupdate",
    tabId: "items",
    targetId: "tour-tu-items-save",
    title: "Save Items",
    content: "Once your items are ready, save them here.",
    placement: "top",
  },
  {
    page: "/admin/themeupdate",
    tabId: "idle",
    targetId: "tour-tu-idle-card",
    title: "Idle Heart Mascots",
    content: "Upload a mascot GIF for each score state (low, mid, high) — shown when the heart is just idling between drops.",
    placement: "top",
  },
  {
    page: "/admin/themeupdate",
    tabId: "clouds",
    targetId: "tour-tu-cloud-card",
    title: "Cloud Image",
    content: "Upload the cloud graphic used as the drag-and-drop backdrop behind each item in the game.",
    placement: "top",
  },
  {
    page: "/admin/themeupdate",
    tabId: "feedback",
    targetId: "tour-tu-feedback-card",
    title: "In-Game Feedback Emojis",
    content: "Edit the emoji and message shown to players based on their live score while they play.",
    placement: "top",
  },
  {
    page: "/admin/themeupdate",
    tabId: "leaderboard",
    targetId: "tour-tu-leaderboard-card",
    title: "Leaderboard Title",
    content: "Set the title shown next to each player's score on the leaderboard, based on their score bracket. That's the full tour — you're all set!",
    placement: "top",
  },
];
